import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";

export const container = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "95vh",
});

export const bodyContainer = ({ breakpoints }: Theme) => ({
  width: { xs: "100%", sm: "500px" },
  height: "100%",
  background: colors.main_gradient,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: { xs: "50px 50px 0 0", sm: "50px" },
  mt: "90px",
  py: "80px",
  boxShadow: {
    sm: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
  },
});

export const subContainer = ({ breakpoints }: Theme) => ({
  mx: "30px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: { xs: "350px", sm: "440px" },
});

export const titleText = ({ breakpoints }: Theme) => ({
  color: "white",
  fontSize: "24px",
  fontWeight: 600,
});

export const buttonContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  width: "100%",
  height: "50px",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const backButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  "&:hover": {
    backgroundColor: colors.light_black,
  },
  margin: "100px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const nextButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  margin: "100px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const input = ({ breakpoints }: Theme) => ({
  mt: 1,
  borderRadius: 4,
  input: {
    background: "white",
    borderRadius: "6px",
  },
});

export const divider = ({ breakpoints }: Theme) => ({
  width: "100%",
  "&::before, &::after": {
    borderColor: colors.light_gray,
  },
  color: colors.dark_gray,
  mt: 1,
  mb: 1,
});

export const authButton = ({ breakpoints }: Theme) => ({
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  fontWeight: 600,
});

export const googleButton = ({ breakpoints }: Theme) => ({
  color: "black",
  textTransform: "none",
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "white",
  },
  fontWeight: 600,
});
